const imp = () => import(/* webpackChunkName: "loadSprite_rich_text"*/  "../sprite/loadSprite_rich_text");
const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-Align-both-ends": imp,
  "Icon-Align-left02": imp,
  "Icon-Align-right02": imp,
  "Icon-Anchor-point02": imp,
  "Icon-Bold": imp,
  "Icon-Block-reference": imp,
  "Icon-Clear-format": imp,
  "Icon-Delete-line": imp,
  "Icon-Delete-link": imp,
  "Icon-Format-brush": imp,
  "Icon-Full-screen": imp,
  "Icon-Insert-horizontal-line": imp,
  "Icon-Numbered-list": imp,
  "Icon-Page-properties": imp,
  "Icon-Page-properties02": imp,
  "Icon-Project-list": imp,
  "Icon-Select-all": imp,
  "Icon-Source-code": imp,
  "Icon-Special-symbols": imp,
  "Icon-Superscript": imp,
  "Icon-Underline": imp,
  "Icon-background-color": imp,
  "Icon-copy02": imp,
  "Icon-decrease-indent": imp,
  "Icon-form": imp,
  "Icon-iframe": imp,
  "Icon-insert-a-page-break": imp,
  "Icon-increase-indent": imp,
  "Icon-link": imp,
  "Icon-redo": imp,
  "Icon-lookup": imp,
  "Icon-replace": imp,
  "Icon-revoke": imp,
  "Icon-shear": imp,
  "Icon-subscript": imp,
  "Icon-text-color02": imp,
  "Icon-tilt": imp,
  "Icon-Align-Bottom": imp,
  "Icon-All-borders": imp,
  "Icon-Center-alignment": imp,
  "Icon-Lower-border": imp,
  "Icon-Text-color": imp,
  "Icon-Top-alignment": imp,
  "Icon-Upload-pictures": imp,
  "Icon-border-left": imp,
  "Icon-border-right": imp,
  "Icon-border-top": imp,
  "Icon-fill-color": imp,
  "Icon-no-border": imp,
  "Icon-watermark": imp,
  "Icon-Center-alignment02": imp,
  "Icon-line-color": imp,
  "Icon-Text-indent": imp,
  "Icon-quote01": imp,
}
export default loadMap;